/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  MFiendCharacteristics,
  MFiendCharacteristicsInterface,
} from "../MFiendCharacteristics";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "affinityToColor",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "affinityToName",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenData",
        type: "uint256",
      },
    ],
    name: "getAffinity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenData",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "affinity",
        type: "uint256",
      },
    ],
    name: "getPalette",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MFiendCharacteristics__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MFiendCharacteristics> {
    return super.deploy(overrides || {}) as Promise<MFiendCharacteristics>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MFiendCharacteristics {
    return super.attach(address) as MFiendCharacteristics;
  }
  connect(signer: Signer): MFiendCharacteristics__factory {
    return super.connect(signer) as MFiendCharacteristics__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MFiendCharacteristicsInterface {
    return new utils.Interface(_abi) as MFiendCharacteristicsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MFiendCharacteristics {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MFiendCharacteristics;
  }
}
